module.exports = __webpack_public_path__ + "static/media/EWayBill_Template_1.8a1178cb.png";